import styled from "styled-components";

import jarsSrc from "../../assets/jars-min.png";

export const Root = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1023px) {
    row-gap: 28px;
  }

  @media (min-width: 1024px) {
    row-gap: 40px;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 1023px) {
    padding: var(--space-2, 16px) var(--space-3, 24px) var(--space-5, 40px)
      var(--space-3, 24px);
  }

  @media (min-width: 1024px) {
    padding: var(--space-2, 16px) var(--space-6, 48px) var(--space-5, 40px)
      var(--space-6, 48px);
  }

  @media (min-width: 1440px) {
    padding: var(--space-2, 16px) var(--space-15, 120px) var(--space-5, 40px)
      var(--space-15, 120px);
  }
`;

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 1023px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: 1024px) {
    justify-content: space-between;
    column-gap: 24px;
  }

  @media (min-width: 1440px) {
    column-gap: 80px;
  }
`;

export const TextContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 1023px) {
    max-width: 508px;
  }

  @media (min-width: 1024px) {
    max-width: 530px;
  }

  @media (min-width: 1440px) {
    max-width: 605px;
  }
`;

export const HeadlineImage = styled.img`
  width: 100%;
  max-width: 508px;
`;

export const HeadlineText = styled.p`
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-transform: uppercase;

  @media (max-width: 1023px) {
    margin-top: 40px;
    margin-bottom: 32px;
    font-size: 24px;
    line-height: 30px;
  }

  @media (min-width: 1024px) {
    margin-top: 56px;
    margin-bottom: 40px;
    font-size: 28px;
    line-height: 34px;
  }

  span {
    color: #caa042;
  }
`;

export const Legal = styled.p`
  margin-bottom: 0;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  letter-spacing: 0.22px;

  @media (max-width: 1023px) {
    margin-top: 56px;
  }

  @media (min-width: 1024px) {
    margin-top: 24px;
  }

  button {
    padding: 0;
    color: #caa042;
    font: inherit;
  }
`;

export const ImagesContainer = styled.div`
  @media (max-width: 1023px) {
    display: none;
  }

  @media (min-width: 1024px) {
    display: flex;
    justify-content: center;
    width: 40%;
    padding: 32px 0;
    background-image: url(${jarsSrc});
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: 75%;
  }

  @media (min-width: 1440px) {
    width: 100%;
    max-width: 520px;
    background-image: url(${jarsSrc});
  }
`;
